import { render, staticRenderFns } from "./DeadlinesPage.vue?vue&type=template&id=80d6d1d8&scoped=true&"
import script from "./DeadlinesPage.vue?vue&type=script&lang=js&"
export * from "./DeadlinesPage.vue?vue&type=script&lang=js&"
import style0 from "./DeadlinesPage.vue?vue&type=style&index=0&id=80d6d1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d6d1d8",
  null
  
)

export default component.exports